module.exports = __webpack_public_path__ + "static/media/challenge-pic.05d7f100.png";